import { types, actions } from './requests'
export const MERGEJOB_TYPES = {
    ...types('MERGEJOB'),
}
export const MERGEJOB_ACTIONS = {
    ...actions('MERGEJOB'),
}
